exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#p2p-crew {\n  position: relative;\n  margin-bottom: 4em;\n}\n#p2p-crew .flex {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n#p2p-crew .item h3 {\n  text-align: left;\n}\n#listContainer{\n  margin: 10px auto;\n    width: 70%;\n}\n\n", ""]);

